import validate from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.17.7_6448f8ee51aa111c8be57d0bb2ba9ecd/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45auth_45required_45global from "/opt/buildhome/repo/packages/nuxt-auth0/src/runtime/middleware/auth-required.global.ts";
import _02_45rbac_45global from "/opt/buildhome/repo/apps/disputes/middleware/02.rbac.global.ts";
export const globalMiddleware = [
  validate,
  _01_45auth_45required_45global,
  _02_45rbac_45global
]
export const namedMiddleware = {
  "claim-lab": () => import("/opt/buildhome/repo/apps/claim-lab/middleware/claim-lab.ts")
}